module.exports = __webpack_public_path__ + "img/gyl-n.0df55f39.png";